"use strict";

// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
var _classCallCheck = require("/home/vsts/work/1/s/platform/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/vsts/work/1/s/platform/node_modules/@babel/runtime/helpers/createClass.js");
var _assertThisInitialized = require("/home/vsts/work/1/s/platform/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
var _get = require("/home/vsts/work/1/s/platform/node_modules/@babel/runtime/helpers/get.js");
var _inherits = require("/home/vsts/work/1/s/platform/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/vsts/work/1/s/platform/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/vsts/work/1/s/platform/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var coreutils_1 = require("@phosphor/coreutils");
var signaling_1 = require("@phosphor/signaling");
var widgets_1 = require("@phosphor/widgets");
var widgets_2 = require("@phosphor/widgets");
var services_1 = require("@jupyterlab/services");
/**
 * The class name added to an output area widget.
 */
var OUTPUT_AREA_CLASS = 'jp-OutputArea';
/**
 * The class name added to the direction children of OutputArea
 */
var OUTPUT_AREA_ITEM_CLASS = 'jp-OutputArea-child';
/**
 * The class name added to actual outputs
 */
var OUTPUT_AREA_OUTPUT_CLASS = 'jp-OutputArea-output';
/**
 * The class name added to prompt children of OutputArea.
 */
var OUTPUT_AREA_PROMPT_CLASS = 'jp-OutputArea-prompt';
/**
 * The class name added to OutputPrompt.
 */
var OUTPUT_PROMPT_CLASS = 'jp-OutputPrompt';
/**
 * The class name added to an execution result.
 */
var EXECUTE_CLASS = 'jp-OutputArea-executeResult';
/**
 * The class name added stdin items of OutputArea
 */
var OUTPUT_AREA_STDIN_ITEM_CLASS = 'jp-OutputArea-stdin-item';
/**
 * The class name added to stdin widgets.
 */
var STDIN_CLASS = 'jp-Stdin';
/**
 * The class name added to stdin data prompt nodes.
 */
var STDIN_PROMPT_CLASS = 'jp-Stdin-prompt';
/**
 * The class name added to stdin data input nodes.
 */
var STDIN_INPUT_CLASS = 'jp-Stdin-input';
/******************************************************************************
 * OutputArea
 ******************************************************************************/
/**
 * An output area widget.
 *
 * #### Notes
 * The widget model must be set separately and can be changed
 * at any time.  Consumers of the widget must account for a
 * `null` model, and may want to listen to the `modelChanged`
 * signal.
 */
var OutputArea = /*#__PURE__*/function (_widgets_2$Widget) {
  _inherits(OutputArea, _widgets_2$Widget);
  var _super = _createSuper(OutputArea);
  /**
   * Construct an output area widget.
   */
  function OutputArea(options) {
    var _this;
    _classCallCheck(this, OutputArea);
    _this = _super.call(this);
    /**
     * A public signal used to indicate the number of outputs has changed.
     *
     * #### Notes
     * This is useful for parents who want to apply styling based on the number
     * of outputs. Emits the current number of outputs.
     */
    _this.outputLengthChanged = new signaling_1.Signal(_assertThisInitialized(_this));
    /**
     * Handle an iopub message.
     */
    _this._onIOPub = function (msg) {
      var model = _this.model;
      var msgType = msg.header.msg_type;
      var output;
      var transient = msg.content.transient || {};
      var displayId = transient['display_id'];
      var targets;
      switch (msgType) {
        case 'execute_result':
        case 'display_data':
        case 'stream':
        case 'error':
          output = msg.content;
          output.output_type = msgType;
          model.add(output);
          break;
        case 'clear_output':
          var wait = msg.content.wait;
          model.clear(wait);
          break;
        case 'update_display_data':
          output = msg.content;
          output.output_type = 'display_data';
          targets = _this._displayIdMap.get(displayId);
          if (targets) {
            var _iterator = _createForOfIteratorHelper(targets),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var index = _step.value;
                model.set(index, output);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
          break;
        default:
          break;
      }
      if (displayId && msgType === 'display_data') {
        targets = _this._displayIdMap.get(displayId) || [];
        targets.push(model.length - 1);
        _this._displayIdMap.set(displayId, targets);
      }
    };
    /**
     * Handle an execute reply message.
     */
    _this._onExecuteReply = function (msg) {
      // API responses that contain a pager are special cased and their type
      // is overridden from 'execute_reply' to 'display_data' in order to
      // render output.
      var model = _this.model;
      var content = msg.content;
      var payload = content && content.payload;
      if (!payload || !payload.length) {
        return;
      }
      var pages = payload.filter(function (i) {
        return i.source === 'page';
      });
      if (!pages.length) {
        return;
      }
      var page = JSON.parse(JSON.stringify(pages[0]));
      var output = {
        output_type: 'display_data',
        data: page.data,
        metadata: {}
      };
      model.add(output);
    };
    _this._minHeightTimeout = null;
    _this._future = null;
    _this._displayIdMap = new Map();
    var model = _this.model = options.model;
    _this.addClass(OUTPUT_AREA_CLASS);
    _this.rendermime = options.rendermime;
    _this.contentFactory = options.contentFactory || OutputArea.defaultContentFactory;
    _this.layout = new widgets_1.PanelLayout();
    for (var i = 0; i < model.length; i++) {
      var output = model.get(i);
      _this._insertOutput(i, output);
    }
    model.changed.connect(_this.onModelChanged, _assertThisInitialized(_this));
    model.stateChanged.connect(_this.onStateChanged, _assertThisInitialized(_this));
    return _this;
  }
  /**
   * A read-only sequence of the chidren widgets in the output area.
   */
  _createClass(OutputArea, [{
    key: "widgets",
    get: function get() {
      return this.layout.widgets;
    }
    /**
     * The kernel future associated with the output area.
     */
  }, {
    key: "future",
    get: function get() {
      return this._future;
    },
    set: function set(value) {
      var _this2 = this;
      // Bail if the model is disposed.
      if (this.model.isDisposed) {
        throw Error('Model is disposed');
      }
      if (this._future === value) {
        return;
      }
      if (this._future) {
        this._future.dispose();
      }
      this._future = value;
      this.model.clear();
      // Make sure there were no input widgets.
      if (this.widgets.length) {
        this._clear();
        this.outputLengthChanged.emit(this.model.length);
      }
      // Handle published messages.
      value.onIOPub = this._onIOPub;
      // Handle the execute reply.
      value.onReply = this._onExecuteReply;
      // Handle stdin.
      value.onStdin = function (msg) {
        if (services_1.KernelMessage.isInputRequestMsg(msg)) {
          _this2.onInputRequest(msg, value);
        }
      };
    }
    /**
     * Dispose of the resources used by the output area.
     */
  }, {
    key: "dispose",
    value: function dispose() {
      if (this._future) {
        this._future.dispose();
      }
      this._future = null;
      this._displayIdMap.clear();
      _get(_getPrototypeOf(OutputArea.prototype), "dispose", this).call(this);
    }
    /**
     * Follow changes on the model state.
     */
  }, {
    key: "onModelChanged",
    value: function onModelChanged(sender, args) {
      switch (args.type) {
        case 'add':
          this._insertOutput(args.newIndex, args.newValues[0]);
          this.outputLengthChanged.emit(this.model.length);
          break;
        case 'remove':
          // Only clear is supported by the model.
          if (this.widgets.length) {
            this._clear();
            this.outputLengthChanged.emit(this.model.length);
          }
          break;
        case 'set':
          this._setOutput(args.newIndex, args.newValues[0]);
          this.outputLengthChanged.emit(this.model.length);
          break;
        default:
          break;
      }
    }
    /**
     * Follow changes on the output model state.
     */
  }, {
    key: "onStateChanged",
    value: function onStateChanged(sender) {
      for (var i = 0; i < this.model.length; i++) {
        this._setOutput(i, this.model.get(i));
      }
      this.outputLengthChanged.emit(this.model.length);
    }
    /**
     * Clear the widget inputs and outputs.
     */
  }, {
    key: "_clear",
    value: function _clear() {
      var _this3 = this;
      // Bail if there is no work to do.
      if (!this.widgets.length) {
        return;
      }
      // Remove all of our widgets.
      var length = this.widgets.length;
      for (var i = 0; i < length; i++) {
        var widget = this.widgets[0];
        widget.parent = null;
        widget.dispose();
      }
      // Clear the display id map.
      this._displayIdMap.clear();
      // When an output area is cleared and then quickly replaced with new
      // content (as happens with @interact in widgets, for example), the
      // quickly changing height can make the page jitter.
      // We introduce a small delay in the minimum height
      // to prevent this jitter.
      var rect = this.node.getBoundingClientRect();
      this.node.style.minHeight = "".concat(rect.height, "px");
      if (this._minHeightTimeout) {
        clearTimeout(this._minHeightTimeout);
      }
      this._minHeightTimeout = window.setTimeout(function () {
        if (_this3.isDisposed) {
          return;
        }
        _this3.node.style.minHeight = '';
      }, 50);
    }
    /**
     * Handle an input request from a kernel.
     */
  }, {
    key: "onInputRequest",
    value: function onInputRequest(msg, future) {
      var _this4 = this;
      // Add an output widget to the end.
      var factory = this.contentFactory;
      var stdinPrompt = msg.content.prompt;
      var password = msg.content.password;
      var panel = new widgets_1.Panel();
      panel.addClass(OUTPUT_AREA_ITEM_CLASS);
      panel.addClass(OUTPUT_AREA_STDIN_ITEM_CLASS);
      var prompt = factory.createOutputPrompt();
      prompt.addClass(OUTPUT_AREA_PROMPT_CLASS);
      panel.addWidget(prompt);
      var input = factory.createStdin({
        prompt: stdinPrompt,
        password: password,
        future: future
      });
      input.addClass(OUTPUT_AREA_OUTPUT_CLASS);
      panel.addWidget(input);
      var layout = this.layout;
      layout.addWidget(panel);
      /**
       * Wait for the stdin to complete, add it to the model (so it persists)
       * and remove the stdin widget.
       */
      input.value.then(function (value) {
        // Use stdin as the stream so it does not get combined with stdout.
        _this4.model.add({
          output_type: 'stream',
          name: 'stdin',
          text: value + '\n'
        });
        panel.dispose();
      });
    }
    /**
     * Update an output in the layout in place.
     */
  }, {
    key: "_setOutput",
    value: function _setOutput(index, model) {
      var layout = this.layout;
      var panel = layout.widgets[index];
      var renderer = panel.widgets ? panel.widgets[1] : panel;
      if (renderer.renderModel) {
        renderer.renderModel(model);
      } else {
        layout.widgets[index].dispose();
        this._insertOutput(index, model);
      }
    }
    /**
     * Render and insert a single output into the layout.
     */
  }, {
    key: "_insertOutput",
    value: function _insertOutput(index, model) {
      var output = this.createOutputItem(model);
      output.toggleClass(EXECUTE_CLASS, model.executionCount !== null);
      var layout = this.layout;
      layout.insertWidget(index, output);
    }
    /**
     * Create an output item with a prompt and actual output
     */
  }, {
    key: "createOutputItem",
    value: function createOutputItem(model) {
      var panel = new widgets_1.Panel();
      panel.addClass(OUTPUT_AREA_ITEM_CLASS);
      var prompt = this.contentFactory.createOutputPrompt();
      prompt.executionCount = model.executionCount;
      prompt.addClass(OUTPUT_AREA_PROMPT_CLASS);
      panel.addWidget(prompt);
      var output = this.createRenderedMimetype(model);
      output.addClass(OUTPUT_AREA_OUTPUT_CLASS);
      panel.addWidget(output);
      return panel;
    }
    /**
     * Render a mimetype
     */
  }, {
    key: "createRenderedMimetype",
    value: function createRenderedMimetype(model) {
      var widget;
      var mimeType = this.rendermime.preferredMimeType(model.data, model.trusted ? 'any' : 'ensure');
      if (mimeType) {
        var metadata = model.metadata;
        var mimeMd = metadata[mimeType];
        var isolated = false;
        // mime-specific higher priority
        if (mimeMd && mimeMd['isolated'] !== undefined) {
          isolated = mimeMd['isolated'];
        } else {
          // fallback on global
          isolated = metadata['isolated'];
        }
        var output = this.rendermime.createRenderer(mimeType);
        if (isolated === true) {
          output = new Private.IsolatedRenderer(output);
        }
        output.renderModel(model).catch(function (error) {
          // Manually append error message to output
          output.node.innerHTML = "<pre>Javascript Error: ".concat(error.message, "</pre>");
          // Remove mime-type-specific CSS classes
          output.node.className = 'p-Widget jp-RenderedText';
          output.node.setAttribute('data-mime-type', 'application/vnd.jupyter.stderr');
        });
        widget = output;
      } else {
        widget = new widgets_2.Widget();
        widget.node.innerHTML = "No ".concat(model.trusted ? '' : '(safe) ', "renderer could be ") + 'found for output. It has the following MIME types: ' + Object.keys(model.data).join(', ');
      }
      return widget;
    }
  }]);
  return OutputArea;
}(widgets_2.Widget);
exports.OutputArea = OutputArea;
var SimplifiedOutputArea = /*#__PURE__*/function (_OutputArea) {
  _inherits(SimplifiedOutputArea, _OutputArea);
  var _super2 = _createSuper(SimplifiedOutputArea);
  function SimplifiedOutputArea() {
    _classCallCheck(this, SimplifiedOutputArea);
    return _super2.apply(this, arguments);
  }
  _createClass(SimplifiedOutputArea, [{
    key: "onInputRequest",
    value:
    /**
     * Handle an input request from a kernel by doing nothing.
     */
    function onInputRequest(msg, future) {
      return;
    }
    /**
     * Create an output item without a prompt, just the output widgets
     */
  }, {
    key: "createOutputItem",
    value: function createOutputItem(model) {
      var output = this.createRenderedMimetype(model);
      output.addClass(OUTPUT_AREA_OUTPUT_CLASS);
      return output;
    }
  }]);
  return SimplifiedOutputArea;
}(OutputArea);
exports.SimplifiedOutputArea = SimplifiedOutputArea;
/**
 * A namespace for OutputArea statics.
 */
(function (OutputArea) {
  /**
   * Execute code on an output area.
   */
  function execute(code, output, session, metadata) {
    // Override the default for `stop_on_error`.
    var content = {
      code: code,
      stop_on_error: true
    };
    if (!session.kernel) {
      return Promise.reject('Session has no kernel.');
    }
    var future = session.kernel.requestExecute(content, false, metadata);
    output.future = future;
    return future.done;
  }
  OutputArea.execute = execute;
  /**
   * The default implementation of `IContentFactory`.
   */
  var ContentFactory = /*#__PURE__*/function () {
    function ContentFactory() {
      _classCallCheck(this, ContentFactory);
    }
    _createClass(ContentFactory, [{
      key: "createOutputPrompt",
      value:
      /**
       * Create the output prompt for the widget.
       */
      function createOutputPrompt() {
        return new OutputPrompt();
      }
      /**
       * Create an stdin widget.
       */
    }, {
      key: "createStdin",
      value: function createStdin(options) {
        return new Stdin(options);
      }
    }]);
    return ContentFactory;
  }();
  OutputArea.ContentFactory = ContentFactory;
  /**
   * The default `ContentFactory` instance.
   */
  OutputArea.defaultContentFactory = new ContentFactory();
})(OutputArea = exports.OutputArea || (exports.OutputArea = {}));
/**
 * The default output prompt implementation
 */
var OutputPrompt = /*#__PURE__*/function (_widgets_2$Widget2) {
  _inherits(OutputPrompt, _widgets_2$Widget2);
  var _super3 = _createSuper(OutputPrompt);
  /*
    * Create an output prompt widget.
    */
  function OutputPrompt() {
    var _this5;
    _classCallCheck(this, OutputPrompt);
    _this5 = _super3.call(this);
    _this5._executionCount = null;
    _this5.addClass(OUTPUT_PROMPT_CLASS);
    return _this5;
  }
  /**
   * The execution count for the prompt.
   */
  _createClass(OutputPrompt, [{
    key: "executionCount",
    get: function get() {
      return this._executionCount;
    },
    set: function set(value) {
      this._executionCount = value;
      if (value === null) {
        this.node.textContent = '';
      } else {
        this.node.textContent = "[".concat(value, "]:");
      }
    }
  }]);
  return OutputPrompt;
}(widgets_2.Widget);
exports.OutputPrompt = OutputPrompt;
/**
 * The default stdin widget.
 */
var Stdin = /*#__PURE__*/function (_widgets_2$Widget3) {
  _inherits(Stdin, _widgets_2$Widget3);
  var _super4 = _createSuper(Stdin);
  /**
   * Construct a new input widget.
   */
  function Stdin(options) {
    var _this6;
    _classCallCheck(this, Stdin);
    _this6 = _super4.call(this, {
      node: Private.createInputWidgetNode(options.prompt, options.password)
    });
    _this6._future = null;
    _this6._input = null;
    _this6._promise = new coreutils_1.PromiseDelegate();
    _this6.addClass(STDIN_CLASS);
    _this6._input = _this6.node.getElementsByTagName('input')[0];
    _this6._input.focus();
    _this6._future = options.future;
    _this6._value = options.prompt + ' ';
    return _this6;
  }
  /**
   * The value of the widget.
   */
  _createClass(Stdin, [{
    key: "value",
    get: function get() {
      var _this7 = this;
      return this._promise.promise.then(function () {
        return _this7._value;
      });
    }
    /**
     * Handle the DOM events for the widget.
     *
     * @param event - The DOM event sent to the widget.
     *
     * #### Notes
     * This method implements the DOM `EventListener` interface and is
     * called in response to events on the dock panel's node. It should
     * not be called directly by user code.
     */
  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      var input = this._input;
      if (event.type === 'keydown') {
        if (event.keyCode === 13) {
          // Enter
          this._future.sendInputReply({
            value: input.value
          });
          if (input.type === 'password') {
            this._value += Array(input.value.length + 1).join('·');
          } else {
            this._value += input.value;
          }
          this._promise.resolve(void 0);
        }
      }
    }
    /**
     * Handle `after-attach` messages sent to the widget.
     */
  }, {
    key: "onAfterAttach",
    value: function onAfterAttach(msg) {
      this._input.addEventListener('keydown', this);
      this.update();
    }
    /**
     * Handle `update-request` messages sent to the widget.
     */
  }, {
    key: "onUpdateRequest",
    value: function onUpdateRequest(msg) {
      this._input.focus();
    }
    /**
     * Handle `before-detach` messages sent to the widget.
     */
  }, {
    key: "onBeforeDetach",
    value: function onBeforeDetach(msg) {
      this._input.removeEventListener('keydown', this);
    }
  }]);
  return Stdin;
}(widgets_2.Widget);
exports.Stdin = Stdin;
/******************************************************************************
 * Private namespace
 ******************************************************************************/
/**
 * A namespace for private data.
 */
var Private;
(function (Private) {
  /**
   * Create the node for an InputWidget.
   */
  function createInputWidgetNode(prompt, password) {
    var node = document.createElement('div');
    var promptNode = document.createElement('pre');
    promptNode.className = STDIN_PROMPT_CLASS;
    promptNode.textContent = prompt;
    var input = document.createElement('input');
    input.className = STDIN_INPUT_CLASS;
    if (password) {
      input.type = 'password';
    }
    node.appendChild(promptNode);
    promptNode.appendChild(input);
    return node;
  }
  Private.createInputWidgetNode = createInputWidgetNode;
  /**
   * A renderer for IFrame data.
   */
  var IsolatedRenderer = /*#__PURE__*/function (_widgets_2$Widget4) {
    _inherits(IsolatedRenderer, _widgets_2$Widget4);
    var _super5 = _createSuper(IsolatedRenderer);
    /**
     * Create an isolated renderer.
     */
    function IsolatedRenderer(wrapped) {
      var _this8;
      _classCallCheck(this, IsolatedRenderer);
      _this8 = _super5.call(this, {
        node: document.createElement('iframe')
      });
      _this8.addClass('jp-mod-isolated');
      _this8._wrapped = wrapped;
      // Once the iframe is loaded, the subarea is dynamically inserted
      var iframe = _this8.node;
      iframe.frameBorder = '0';
      iframe.scrolling = 'auto';
      iframe.addEventListener('load', function () {
        // Workaround needed by Firefox, to properly render svg inside
        // iframes, see https://stackoverflow.com/questions/10177190/
        // svg-dynamically-added-to-iframe-does-not-render-correctly
        iframe.contentDocument.open();
        // Insert the subarea into the iframe
        // We must directly write the html. At this point, subarea doesn't
        // contain any user content.
        iframe.contentDocument.write(_this8._wrapped.node.innerHTML);
        iframe.contentDocument.close();
        var body = iframe.contentDocument.body;
        // Adjust the iframe height automatically
        iframe.style.height = body.scrollHeight + 'px';
      });
      return _this8;
    }
    /**
     * Render a mime model.
     *
     * @param model - The mime model to render.
     *
     * @returns A promise which resolves when rendering is complete.
     *
     * #### Notes
     * This method may be called multiple times during the lifetime
     * of the widget to update it if and when new data is available.
     */
    _createClass(IsolatedRenderer, [{
      key: "renderModel",
      value: function renderModel(model) {
        var _this9 = this;
        return this._wrapped.renderModel(model).then(function () {
          var win = _this9.node.contentWindow;
          if (win) {
            win.location.reload();
          }
        });
      }
    }]);
    return IsolatedRenderer;
  }(widgets_2.Widget);
  Private.IsolatedRenderer = IsolatedRenderer;
})(Private || (Private = {}));